export default __webpack_public_path__ + "static/getting02-8fea9e90a848f67804d1c7d5c28d92bb.png";